import React, {useState} from 'react'
import NajavaUtovaraModal from './NajavaUtovaraModal'
import {createThermoboardRoba} from './ThermoboardRobaTable'

type Props = {
  onClose: () => void
  onCreated: () => void
  initialKupac?: string
}

const ThermoboardNajavaModal = ({onClose, onCreated, initialKupac = ''}: Props) => {
  const [rowsByTruck, setRowsByTruck] = useState<any[][]>(() => [[createThermoboardRoba()]])

  return (
    <NajavaUtovaraModal
      showModal
      manual
      initialKupac={initialKupac}
      groupedRobaByTruck={rowsByTruck}
      setGroupedRobaByTruck={setRowsByTruck}
      onClose={onClose}
      onCreated={onCreated}
    />
  )
}

export default ThermoboardNajavaModal
